module.exports = __webpack_public_path__ + "media/parents/important-dates-c772db24.png";